import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { BadgeModule } from '../badge/badge.module';
import { ButtonModule } from '../button/button.module';
import { DropdownItemModule } from '../dropdown/dropdown-item/dropdown-item.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { GroupModule } from '../group/group.module';
import { HeadingModule } from '../heading/heading.module';
import { IconModule } from '../icon/icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IntegrationItemComponent } from './integration-item.component';

@NgModule({
  imports: [
    CommonModule,
    HeadingModule,
    ButtonModule,
    BadgeModule,
    GroupModule,
    TooltipModule,
    RtUICoreOverlayModule,
    IconModule,
    DropdownItemModule,
    DropdownModule,
    I18nModule,
  ],
  declarations: [IntegrationItemComponent],
  exports: [IntegrationItemComponent],
})
export class IntegrationItemModule {}
export { IntegrationItemComponent } from './integration-item.component';
